export interface BookHighlight {
  title: string;
  author: string;
  image: string;
  quote: string;
  desc: string;
}

export interface Article {
  slug: string;
  title: string;
  subtitle: string;
  category: string;
  categoryColor: string;
  coverImage: string;
  date: string;
  readTime: string;
  content: string[];
  books?: BookHighlight[];
}

export const articles: Article[] = [
  {
    slug: 'anxiety-cycle',
    title: '打破焦慮循環：從心靈根源找回內在平靜',
    subtitle: '學識「覺察」，將個心帶返當下，你會發現最安全嘅力量一直都在內在。',
    category: '心靈覺醒',
    categoryColor: 'primary',
    coverImage:
      'https://storage.readdy-site.link/project_files/80621f35-4526-4d61-b800-6d2f08be7197/94aa1625-72bd-4701-9fca-33680273caa0_compressed_Screenshot_20260725_001738_Gallery.webp',
    date: '2026.07.15',
    readTime: '約 4 分鐘',
    content: [
      '現代人生活節奏快到停唔到落嚟，每日一睜大眼，排山倒海嘅資訊、工作同生活壓力就撲面而嚟。不知不覺之間，個心好似長期吊吊揈，呢種莫名其妙嘅心慌同焦慮，其實係身體同心靈向你發出嘅求救訊號。',
      '好多人以為，解決焦慮嘅方法係去瘋狂消費、煲劇或者食餐好。但當熱鬧過後，夜深人靜時候，嗰種空虛感同無力感又會再次來襲。因為呢啲方法只係短暫嘅麻醉，並冇真正接到焦慮嘅根源。',
      '要打破呢個焦慮循環，我哋首先要學識「覺察」。當下一次心跳加速、個腦停唔到去諗衰嘢時候，唔好急住去逃避佢。試下將手放心口，同自己講一聲：「我睇到你喇，你依家好唔舒服嘅，我喺度。」',
      '焦慮往往來自於我哋對未來「未發生」事情嘅恐懼，或者係對過去「已經發生」事情嘅執著。唯有將個心帶返嚟呢一刻，專注你依家吸緊呢一啖氣、飲緊呢一啖水。當你容許自己當下停一停，你會發現，原來最安全、最踏實嘅力量，一直都喺你嘅內在。',
    ],
  },
  {
    slug: 'embrace-shadow',
    title: '擁抱陰暗面：點樣同自己的不完美和解',
    subtitle: '真正嘅心靈健康，從來都唔係做一個「完美無瑕」嘅聖人，而係做一個「完整」嘅人。',
    category: '自我療癒',
    categoryColor: 'secondary',
    coverImage:
      'https://storage.readdy-site.link/project_files/80621f35-4526-4d61-b800-6d2f08be7197/6fcad341-39e6-4dff-83eb-083e30975d5b_compressed_Screenshot_20260722_224224_Gallery.webp',
    date: '2026.07.10',
    readTime: '約 4 分鐘',
    content: [
      '喺社會標準同期望之下，我哋自小就被教導要表現得積極、大方、溫柔同完美。於是，我哋好努力將自己嘅嫉妒、軟弱、憤怒同自私收藏喺心底最深處，唔敢畀任何人睇到，甚至連自己都唔想承認。',
      '呢啲被我哋否定同排斥嘅部分，心理學上被稱為「陰影（Shadow）」。當我哋越想去消滅佢、壓抑佢，佢反而會喺意想不到嘅時候，以更加猛烈嘅方式爆發出嚟，例如突然失控嘅脾氣，或者莫名其妙嘅自我否定。',
      '真正嘅心靈健康，從來都唔係要追求做一個「完美無瑕」嘅聖人，而係做一個「完整」嘅人。每個人都有光明嘅一面，自然亦會有陰暗嘅角落。嫉妒可能代表你心底裡其實好渴望得到某種肯定；憤怒可能係在提醒你，你嘅底線已經被踩中。',
      '試下用一個慈悲嘅眼神，去凝視自己嗰啲不完美。當你學會同自己嘅陰暗面握手言和，接納自己可以嘅有軟弱同犯錯時候，你先至會感受到前所未有嘅輕鬆。擁抱不完美，你先可以活得最真實、最自在。',
    ],
  },
  {
    slug: 'spiritual-books',
    title: '【心靈書單】推薦三本喚醒內在力量與靈魂藍圖的必讀著作',
    subtitle: '透過三本靈性著作嘅智慧，重新找回內在嘅踏實感同力量。',
    category: '心靈覺醒',
    categoryColor: 'primary',
    coverImage:
      'https://storage.readdy-site.link/project_files/80621f35-4526-4d61-b800-6d2f08be7197/833644a7-19bd-45a4-b4a1-326361346a2d_compressed_Screenshot_20260724_233151_Gallery.webp',
    date: '2026.07.05',
    readTime: '約 5 分鐘',
    content: [
      '無論你在生活之中面對點樣嘅抉擇，下下子路都在提醒我哋，好好留在此時此地。當感到迷茫同焦慮嘅時候，不妨將視角提升到心靈同靈魂層面，透過以下三本著作嘅智慧，重新找回內在嘅踏實感同力量。',
      '「往左行定往右行，其實無對錯之分。每一次站在分岔路口，都是靈魂為了遇見更好的自己，而做出嘅神聖選擇。」讀懂呢三本書嘅智慧，當我哋再次凝視生活之中嘅抉擇時，心中就會多了一份坦然。我哋唔需要再害怕錯路，因為人生根本冇錯路。不論是生活上嘅大波動、生命中遇到嘅困難，定係對人生意義嘅追尋，全部經歷最終都會變成我哋內在嘅養分。每位讀者都能在平日嘅每一次呼吸之中，感受到內在源源不絕嘅力量同溫暖。',
    ],
    books: [
      {
        title: '《一個新世界：喚醒內在的力量》',
        author: 'Eckhart Tolle',
        image:
          'https://storage.readdy-site.link/project_files/80621f35-4526-4d61-b800-6d2f08be7197/e6daeb39-64ad-4aa0-9898-869a5f4383f4_compressed_ec195827.webp',
        quote: '「當你與當下時刻和解，看看會發生什麼事，你做什麼事都會充滿了當下的力量。」',
        desc: '呢本書深入探討舊有物質主義體制同埋小我（Ego）主導社會嘅逐漸瓦解。佢話俾我哋知，集體嘅恐懼同焦慮其實只係舊世界告別前嘅陣痛。每一個靈魂都被邀請去提升自己嘅振動頻率，放下盲目嘅追求，好好回歸當下。',
      },
      {
        title: '《靈魂的出生前計畫》',
        author: 'Robert Schwartz',
        image:
          'https://storage.readdy-site.link/project_files/80621f35-4526-4d61-b800-6d2f08be7197/2e7f444b-bd5c-4848-8bd6-5e9feedba58e_compressed_ec671983-1.webp',
        quote: '「痛苦不會平白無故發生。它是靈魂精心設計的試煉，為了讓你在黑暗中記起自己是光。」',
        desc: '呢本書徹底顛覆咗大家一貫嘅「受害者心態」。作者揭示我哋在出生之前，一早已經同靈魂伴侶規劃好咗呢一生嘅主要挑戰（例如疾病或重大挫折）。呢啲體驗並唔係懲罰，而係靈魂為了學習無條件的愛、寬恕同內在力量，而主動做出嘅神聖約定。',
      },
      {
        title: '《名望，財富與野心》',
        author: '奧修 Osho',
        image:
          'https://storage.readdy-site.link/project_files/80621f35-4526-4d61-b800-6d2f08be7197/ec7049c7-e877-4296-8736-bafff9dda8db_compressed_20211224035353691690.webp',
        quote: '「如果你內在是空虛的，外在的名利只會凸顯你的貧乏。真正的成功，是你在孤獨中也能感到無比的富有。」',
        desc: '奧修大師以極其穿透力嘅筆觸，直視現代人對名利嘅終極焦慮。佢指出世俗定義嘅成功往往只係一場小我陷阱。真正嘅成功從來都唔係要贏過邊個，而係同內在永恆不滅嘅「觀照者」連結，在日常之中活出絕對嘅自由。',
      },
    ],
  },
  {
    slug: 'mindfulness-guide',
    title: '日常正念指南：在忙碌生活之中找回呼吸節奏',
    subtitle: '正念唔係盤坐幾個鐘頭唔郁，而係一種生活態度。',
    category: '正念生活',
    categoryColor: 'accent',
    coverImage:
      'https://storage.readdy-site.link/project_files/80621f35-4526-4d61-b800-6d2f08be7197/a8fd5dc0-5c19-4c64-894a-d81e086392a2_compressed_Screenshot_20260722_224636_Gallery.webp',
    date: '2026.06.28',
    readTime: '約 4 分鐘',
    content: [
      '「正念（Mindfulness）」聽落去好似好高深、好有宗教色彩？其實完全唔係。正念最簡單嘅定義，就係「有意圖地、不加評判地，將注意力帶回當下這一刻」。它唔係要你盤坐幾個鐘頭都唔郁，而係一種生活嘅態度。',
      '你返工、搭車、甚至洗碗嘅時候，你都可以練習正念。例如每日朝早刷牙嘅時候，試下唔好去諗一陣返工有排山倒海嘅 Email 要覆，轉為去感受吓牙膏嘅薄荷味、牙刷刷過牙齒嘅感覺、同埋暖水漱口時嘅溫度。',
      '當你搭地鐵嘅時候，唔好一味低頭睇電話，試下將雙腳牢牢踩實車廂地面，感受吓架車行時嘅震動，留意一下身邊經過嘅人。呢啲微小嘅專注，就可以令你將過度運作、差唔多要爆胎嘅大腦，暫時切換去「休息模式」。',
      '每個人每日都有24小時，我哋好難控制外在環境有幾亂，但可以決定自己嘅心點樣去回應。當你學識喺生活中溫柔地踩低個迫力掣（Brake），你就會發覺，原來就算世界再複雜，你內心依然可以保留一塊安全、寧靜嘅落腳點。',
    ],
  },
  {
    slug: 'inner-child',
    title: '內在小孩療癒：執返起嗰個受傷嘅自己',
    subtitle: '兒時嘅委屈並唔會隨住年齡長大而消失，它們會變成「內在小孩」，一直匿喺潛意識深處。',
    category: '自我療癒',
    categoryColor: 'secondary',
    coverImage:
      'https://storage.readdy-site.link/project_files/80621f35-4526-4d61-b800-6d2f08be7197/90d61d3b-d9e4-417f-8b08-d166faaa66a9_compressed_Screenshot_20260722_220504_Instagram.webp',
    date: '2026.06.20',
    readTime: '約 4 分鐘',
    content: [
      '你細個嘅時候，有冇試過因為打破嘢被大喊大叫、因為考試考得衰被否定，或者在需要陪伴嘅時候被大人忽略？呢啲兒時受過嘅委屈、恐懼同失落，並唔會隨住你年齡長大、著起西裝返工而自然消失。它們會變成一個「內在小孩（Inner Child）」，一直匿喺你嘅潛意識深處。',
      '每當我哋喺現實生活遇到挫折、被人拒絕，或者同伴侶鬧交嘅時候，嗰種突然湧上嚟、過度強烈嘅委屈同憤怒，往往唔係因為眼前呢件事，而是你體內嗰個受咗傷嘅細路，再次被勾起當年嘅陰影，喺度痛哭大叫。',
      '療癒內在小孩，第一步係要去承認佢嘅存在。在夜深人靜、或者你覺得好委屈嘅時候，閉上眼，想像一下七、八歲時嘅自己。望住佢，用你依家成年人嘅成熟力量去同佢講：「對唔住，我以前忽略咗你。但依家我大個仔／大個女喇，我好有能力，我以後會好好保護你、愛護你，你安全喇。」',
      '你唔需要去期待當年傷害過你嘅人同你道歉，因為最能給予你安全感同無條件愛護嘅人，從來都唔係外在任何人，而係依家呢一個、已經有足夠力量去抱緊過去自己嘅你。執返起呢個受傷嘅自己，你先至可以完整向前行。',
    ],
  },
  {
    slug: 'movie-psychology',
    title: '【電影心靈學】從《寂寞的朋友》睇樹木同我哋的神經共鳴',
    subtitle: '森林地底下隱藏住「植物網（Wood Wide Web）」，運作模式同人類神經網絡一模一樣。',
    category: '大自然療癒',
    categoryColor: 'primary',
    coverImage:
      'https://storage.readdy-site.link/project_files/80621f35-4526-4d61-b800-6d2f08be7197/deb34301-646f-40cd-8536-81087ba01746_compressed_Screenshot_20260724_185640_Instagram.webp',
    date: '2026.06.12',
    readTime: '約 5 分鐘',
    content: [
      '唔知你有冇睇過《寂寞的朋友》（The Lonely Man）呢套觸動內心嘅電影？入面嗰種人與大自然之間、寂靜卻又無比深厚嘅連結，睇完真係令人起晒皮疙瘩。可能好多人會覺得：「電影情節啫，樹又冇大腦，邊會有啲相通嘅感受？」但其實神經科學已經證實——大自然同我哋人類，有極其相似嘅「連結感」。',
      '著名神經科學與生態學研究指出，森林地底下其實隱藏住一個極其龐大嘅「菌根網絡（Mycorrhizal Network）」，科學家親切地稱佢為「植物網（Wood Wide Web）」。呢個網絡嘅運作模式，同我哋人類大腦入面傳遞訊息嘅「神經網絡」簡直一模一樣！當其中一棵樹唔夠水分、或者受到侵害，佢會透過地底網絡將化學訊號同電流，好似神經脈衝咁傳遍全身，等大家一齊伸出援手。樹木，其實從來都唔孤單，它們一直都在互相對話、互相照顧。',
      '電影入面嗰種「寂寞」，其實係當現代人同呢個大地網絡斷開連結之後，靈魂所產生嘅空虛。當你行入森林或者公園，伸手摸一棵樹嘅時候，你腦內嘅腦電波其實會慢慢同植物嘅振動頻率產生共鳴。樹木釋放嘅芬多精，會直接安定你體內過度活躍嘅交感神經，令壓力荷爾蒙（皮質醇）指數急降。科學同我哋證明：你同樹木嘅連結係真嘅。每一次你覺得世界好嘈、自己好寂寞嘅時候，試下好似電影入面咁，靜靜地行去樹下。你會發現，只要你願意重新連結，呢個地球綠色神經網絡，一早已經準備好溫柔地接住你。',
    ],
  },
  {
    slug: 'earthing',
    title: '【接地氣療癒】赤腳踩草沙與凝望晨昏：最天然的身心修復術',
    subtitle: '地球表面充滿天然負電子，赤腳踩地20分鐘就能顯著降低發炎反應。',
    category: '正念生活',
    categoryColor: 'accent',
    coverImage:
      'https://storage.readdy-site.link/project_files/80621f35-4526-4d61-b800-6d2f08be7197/193353bb-3cde-42b1-a734-ced21e5a239d_compressed_Screenshot_20260724_232726_Gallery.webp',
    date: '2026.06.05',
    readTime: '約 5 分鐘',
    content: [
      '現代人每日著住厚厚嘅膠底鞋，生活充滿 Wi-Fi、微波同電子產品嘅石屎森林入面，體內其實積聚大量未能釋放嘅正電荷（自由基），這亦是導致都市人長期發炎、失眠同情緒低落嘅根源。想要改善呢個狀況？方法其實好簡單、好貼地，就係進行「接地氣（Earthing／Grounding）」。',
      '地球表面充滿了無窮無盡嘅天然負電子。當你除咗鞋襪，用最赤裸嘅雙腳直接踩喺沙灘嘅濕沙上，或者公園嘅青草地上時，奇妙嘅物理現象就會發生：你身體所累積嘅正電荷會瞬間被大地吸走，而大地嘅負電子會傳回體內，達致電位平衡。醫學研究發現，短短20分鐘嘅接地氣，就能夠顯著降低體內嘅發炎反應，令肌肉放鬆，甚至連血液循環同睡眠質素都會得到神奇改善。呢種與大地最直接嘅皮膚接觸，係最唔花分文嘅天然止痛劑。',
      '除了用腳踩，我哋仲可以用雙眼去接收大自然嘅修復訊號——那就係在「日出前」或「日落後」呢兩段黃金時間（科學上稱為 Golden Hour）去捕捉天然光線。呢兩個時段嘅光線中，紅光與近紅外線（Near-Infrared Light）嘅比例最高，而且完全冇傷皮膚嘅紫外線。當呢種柔和嘅溫光進入我哋嘅視網膜，佢會直接刺激大腦調整褪黑激素與血清素分泌，重新校正我哋嘅「晝夜節律」（生物鐘）。更厲害嘅係，近紅外線能穿透皮膚，活化細胞入面嘅線粒體，令身體細胞進行深度充電與修復。每日給自己10分鐘，赤腳踩踩地、靜心望望晨昏天色，你會發現，最好嘅醫生，其實一直都在你身邊。',
    ],
  },
];

export function getArticleBySlug(slug: string): Article | undefined {
  return articles.find((a) => a.slug === slug);
}